
export default {
  name: 'DialogView',
  components: {
  },
  props: {
    comp: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      value: null
    }
  },
  computed: {
    dialogInfo (): any {
      return this.$store.getters['ui/dialogInfo']
    },
    param (): any {
      return this.comp.param
    },
    secondParam (): any {
      return this.comp.secondParam
    }
  },
  mounted () {
    this.value = this.comp.component
  }
}
